"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_OG_TAGS = void 0;
var DEFAULT_OG_TAGS = {
  // eslint-disable-next-line no-template-curly-in-string
  title: 'Hi ${recipientName}',
  description: 'Your personalised Elevate is ready!',
  thumbnail: 'https://d3on5ehsnqzzp4.cloudfront.net/Splash/Elevate/default-preview-image.png'
};
exports.DEFAULT_OG_TAGS = DEFAULT_OG_TAGS;